import { useEffect } from "react";

import {
  appBarStore,
  APP_BAR_EMPTY_ACTIONS,
  APP_BAR_EMPTY_MIDDLE_COMPONENTS,
  APP_BAR_EMPTY_RIGHT_COMPONENTS,
} from "@/store/AppBarStore";

/**
 * Applies {@link appBarStore.setConfig} while mounted and clears the AppBar on unmount.
 * Memoize `rightComponents`, `middleComponents`, and `actions` when they contain JSX so
 * dependencies stay stable across renders.
 *
 * @param {Object} config
 * @param {string} [config.title]
 * @param {Array<{ onClick: Function, icon?: import("react").ReactNode, color?: string }>} [config.actions]
 * @param {{ onClick: Function, icon?: import("react").ReactNode } | null} [config.backAction]
 * @param {import("react").ReactNode[]} [config.middleComponents]
 * @param {import("react").ReactNode[]} [config.rightComponents]
 * @param {boolean} [config.suppressFixedBar=false] - On desktop, hide the fixed app bar chrome (mobile keeps the bar for the menu).
 * @param {boolean} [config.hideMobileMenuButton=false] - On mobile, hide the hamburger (use with {@link rightComponents} e.g. close).
 * @param {boolean} [config.mobileTitleRowInlineActions=false] - Mobile prompt header: put {@link rightComponents} on the same row as the title (narrow viewports).
 * @param {boolean} [config.mobileGlassMapHeader=false] - Mobile map pages: dark frosted app bar over the map.
 * @param {boolean} [config.mobileLavenderMapHeader=false] - Mobile map pages: opaque lavender app bar when drawer is closed.
 */
export default function useAppBar(config) {
  const raw = config ?? {};
  const title = raw.title ?? "";
  const actions = raw.actions ?? APP_BAR_EMPTY_ACTIONS;
  const backAction = raw.backAction ?? null;
  const middleComponents = raw.middleComponents ?? APP_BAR_EMPTY_MIDDLE_COMPONENTS;
  const rightComponents = raw.rightComponents ?? APP_BAR_EMPTY_RIGHT_COMPONENTS;
const suppressFixedBar = Boolean(raw.suppressFixedBar);
const hideMobileMenuButton = Boolean(raw.hideMobileMenuButton);
const hideMobileMenu = Boolean(raw.hideMobileMenu);
const mobileTitleRowInlineActions = Boolean(raw.mobileTitleRowInlineActions);
const mobileGlassMapHeader = Boolean(raw.mobileGlassMapHeader);
const mobileLavenderMapHeader = Boolean(raw.mobileLavenderMapHeader);

  useEffect(() => {
appBarStore.setConfig({
  title,
  actions,
  backAction,
  middleComponents,
  rightComponents,
  suppressFixedBar,
  hideMobileMenuButton,
  hideMobileMenu,
  mobileTitleRowInlineActions,
  mobileGlassMapHeader,
  mobileLavenderMapHeader,
});
    return () => {
      appBarStore.clear();
    };
}, [
  title,
  actions,
  backAction,
  middleComponents,
  rightComponents,
  suppressFixedBar,
  hideMobileMenuButton,
  hideMobileMenu,
  mobileTitleRowInlineActions,
  mobileGlassMapHeader,
  mobileLavenderMapHeader,
]);
}
